<template>

		<main class="">
			<div class="max-w-7xl mx-auto pb-12 px-4 sm:px-6 lg:px-8">
				<!-- Replace with your content -->
<!--				<IconList :icons="icons"></IconList>-->
				<!-- /End replace -->

				<div id="product-marketing-sections" class="grid grid-cols-3 xl:grid-cols-4 py-8 gap-x-8 gap-y-6">
					<h3 class="text-gray-900 font-semibold col-span-3 xl:col-span-1">Slide Components</h3>
					<div class="col-span-3 grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-y-8 lg:gap-x-8">
						<Link href="/templates/three-column-layouts" class="group relative bg-white rounded-lg shadow-sm overflow-hidden ring-1 ring-black ring-opacity-5" >
							<div class="relative bg-gray-100 pt-[50%] overflow-hidden">
								<div class="absolute inset-0 w-full h-full rounded-t-lg overflow-hidden">
									<img src="/thumbnails/threeColumn_blue.png" alt="" class="absolute inset-0 w-full h-full">
								</div>
							</div>
							<div class="py-3 px-4">
								<p class="text-sm font-medium text-gray-900 mb-1">
									Three Column Text
								</p>
								<p class="text-xs font-medium text-gray-500">9 components</p>
							</div>
						</Link>

						<Link href="/templates/timelines-gantt" class="group relative bg-white rounded-lg shadow-sm overflow-hidden ring-1 ring-black ring-opacity-5">
							<div class="relative bg-gray-100 pt-[50%] overflow-hidden">
								<div class="absolute inset-0 w-full h-full rounded-t-lg overflow-hidden">
									<img src="/thumbnails/threeColumn_blue.png" alt="" class="absolute inset-0 w-full h-full">
								</div>
							</div>
							<div class="py-3 px-4">
								<p class="text-sm font-medium text-gray-900 mb-1">
									Timeline/ Roadmaps
								</p>
								<p class="text-xs font-medium text-gray-500">9 components</p>
							</div>
						</Link>

						<a href="#" class="group relative bg-white rounded-lg shadow-sm overflow-hidden ring-1 ring-black ring-opacity-5">
							<div class="relative bg-gray-100 pt-[50%] overflow-hidden">
								<div class="absolute inset-0 w-full h-full rounded-t-lg overflow-hidden">
									<img src="/thumbnails/threeColumn_blue.png" alt="" class="absolute inset-0 w-full h-full">
								</div>
							</div>
							<div class="py-3 px-4">
								<p class="text-sm font-medium text-gray-900 mb-1">
									Chart Elements
								</p>
								<p class="text-xs font-medium text-gray-500">9 components</p>
							</div>
						</a>



						<a href="https://tailwindui.com/img/components/marketing/sections/feature-sections" class="group relative bg-white rounded-lg shadow-sm overflow-hidden ring-1 ring-black ring-opacity-5">
							<div class="relative bg-gray-100 pt-[50%] overflow-hidden">
								<div class="absolute inset-0 w-full h-full rounded-t-lg overflow-hidden">
									<img src="/img/category-thumbnails/marketing/feature-sections.png" alt="" class="absolute inset-0 w-full h-full">
								</div>
							</div>
							<div class="py-3 px-4">
								<p class="text-sm font-medium text-gray-900 mb-1">
									Feature Sections
								</p>
								<p class="text-xs font-medium text-gray-500">10 components</p>
							</div>
						</a>
						<a href="https://tailwindui.com/img/components/marketing/sections/cta-sections" class="group relative bg-white rounded-lg shadow-sm overflow-hidden ring-1 ring-black ring-opacity-5">
							<div class="relative bg-gray-100 pt-[50%] overflow-hidden">
								<div class="absolute inset-0 w-full h-full rounded-t-lg overflow-hidden">
									<img src="/img/category-thumbnails/marketing/cta-sections.png" alt="" class="absolute inset-0 w-full h-full">
								</div>
							</div>
							<div class="py-3 px-4">
								<p class="text-sm font-medium text-gray-900 mb-1">
									CTA Sections
								</p>
								<p class="text-xs font-medium text-gray-500">8 components</p>
							</div>
						</a>
						<a href="https://tailwindui.com/img/components/marketing/sections/pricing" class="group relative bg-white rounded-lg shadow-sm overflow-hidden ring-1 ring-black ring-opacity-5">
							<div class="relative bg-gray-100 pt-[50%] overflow-hidden">
								<div class="absolute inset-0 w-full h-full rounded-t-lg overflow-hidden">
									<img src="/img/category-thumbnails/marketing/pricing.png" alt="" class="absolute inset-0 w-full h-full">
								</div>
							</div>
							<div class="py-3 px-4">
								<p class="text-sm font-medium text-gray-900 mb-1">
									Pricing Sections
								</p>
								<p class="text-xs font-medium text-gray-500">9 components</p>
								<p class="absolute z-10 top-3 right-3 text-white bg-gray-900 bg-opacity-30 rounded-full flex items-center justify-center p-1">
									<span class="sr-only">PNG previews only, upgrade to get the HTML.</span>
									<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" class="w-6 h-6">
										<path d="M5.75 11.75a1 1 0 011-1h10.5a1 1 0 011 1v5.5a2 2 0 01-2 2h-8.5a2 2 0 01-2-2v-5.5zM7.75 10.5v-.157c0-1.562-.094-3.302.996-4.42C9.368 5.288 10.374 4.75 12 4.75c1.626 0 2.632.537 3.254 1.174 1.09 1.117.996 2.857.996 4.419v.157" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
									</svg>
								</p>
							</div>
						</a>

					</div>
				</div>




				<div id="icon-sections" class="grid grid-cols-3 xl:grid-cols-4 py-8 gap-x-8 gap-y-6">
					<h3 class="text-gray-900 font-semibold col-span-3 xl:col-span-1">Icon Packs</h3>
					<div class="col-span-3 grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-y-8 lg:gap-x-8">
						<Link href="/icons/heroicons" class="group relative bg-white rounded-lg shadow-sm overflow-hidden ring-1 ring-black ring-opacity-5">
							<div class="relative bg-gray-100 pt-[50%] overflow-hidden">
								<div class="absolute inset-0 w-full h-full rounded-t-lg overflow-hidden">
									<img src="/thumbnails/heroicons_thumbnail.png" alt="" class="absolute inset-0 w-full h-full">
								</div>
							</div>
							<div class="py-3 px-4">
								<p class="text-sm font-medium text-gray-900 mb-1">
									Heroicons
								</p>
								<p class="text-xs font-medium text-gray-500">230 icons</p>
							</div>
						</Link>
						<a href="#" class="group relative bg-white rounded-lg shadow-sm overflow-hidden ring-1 ring-black ring-opacity-5">
							<div class="relative bg-gray-100 pt-[50%] overflow-hidden">
								<div class="absolute inset-0 w-full h-full rounded-t-lg overflow-hidden brightness-75">
									<img src="/thumbnails/iconoir_thumbnail.png" alt="" class="absolute inset-0 w-full h-full">
								</div>
							</div>
							<div class="py-3 px-4">
								<p class="text-sm font-medium text-gray-900 mb-1">
									Iconoir
								</p>
								<p class="text-xs font-medium text-gray-500">1091 icons</p>
								<p class="absolute bg-opacity-90 bg-yellow-400 flex from-yellow-100 items-center justify-center p-1 px-3 right-3 rounded-full shadow text-slate-800 text-sm to-slate-100 top-3 z-10">
									Coming soon
								</p>
							</div>
						</a>
						<a href="#" class="group relative bg-white rounded-lg shadow-sm overflow-hidden ring-1 ring-black ring-opacity-5">
							<div class="relative bg-gray-100 pt-[50%] overflow-hidden">
								<div class="absolute inset-0 w-full h-full rounded-t-lg overflow-hidden brightness-90">
									<img src="/thumbnails/tabler_thumbnail.png" alt="" class="absolute inset-0 w-full h-full">
								</div>
							</div>
							<div class="py-3 px-4">
								<p class="text-sm font-medium text-gray-900 mb-1">
									Tabler
								</p>
								<p class="text-xs font-medium text-gray-500">1900 icons</p>
								<p class="absolute bg-opacity-90 bg-yellow-400 flex from-yellow-100 items-center justify-center p-1 px-3 right-3 rounded-full shadow text-slate-800 text-sm to-slate-100 top-3 z-10">
									Coming soon
								</p>
							</div>
						</a>
<!--						<a href="https://tailwindui.com/img/components/marketing/sections/pricing" class="group relative bg-white rounded-lg shadow-sm overflow-hidden ring-1 ring-black ring-opacity-5">-->
<!--							<div class="relative bg-gray-100 pt-[50%] overflow-hidden">-->
<!--								<div class="absolute inset-0 w-full h-full rounded-t-lg overflow-hidden">-->
<!--									<img src="/img/category-thumbnails/marketing/pricing.png" alt="" class="absolute inset-0 w-full h-full">-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="py-3 px-4">-->
<!--								<p class="text-sm font-medium text-gray-900 mb-1">-->
<!--									Pricing Sections-->
<!--								</p>-->
<!--								<p class="text-xs font-medium text-gray-500">9 components</p>-->
<!--								<p class="absolute z-10 top-3 right-3 text-white bg-gray-900 bg-opacity-30 rounded-full flex items-center justify-center p-1">-->
<!--									<span class="sr-only">PNG previews only, upgrade to get the HTML.</span>-->
<!--									<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" class="w-6 h-6">-->
<!--										<path d="M5.75 11.75a1 1 0 011-1h10.5a1 1 0 011 1v5.5a2 2 0 01-2 2h-8.5a2 2 0 01-2-2v-5.5zM7.75 10.5v-.157c0-1.562-.094-3.302.996-4.42C9.368 5.288 10.374 4.75 12 4.75c1.626 0 2.632.537 3.254 1.174 1.09 1.117.996 2.857.996 4.419v.157" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>-->
<!--									</svg>-->
<!--								</p>-->
<!--							</div>-->
<!--						</a>-->

					</div>
				</div>

			</div>
		</main>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import HeaderNav from '@/Layouts/HeaderNav'
import LandingHeader from '@/Layouts/LandingHeader'

export default {
	// Using the shorthand
	layout: LandingHeader,
	// layout: [HeaderNav, LandingHeader],
}
</script>


<script setup>
import { Head, Link } from '@inertiajs/vue3';
import { ref, reactive, computed } from 'vue';



const props = defineProps({
	icons: Object,
	canLogin: Boolean,
	canRegister: Boolean,
})

</script>